import { render, staticRenderFns } from "./MainInvestor.vue?vue&type=template&id=7dbd86bc&"
import script from "./MainInvestor.vue?vue&type=script&lang=js&"
export * from "./MainInvestor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports